import React from 'react';
import { Link } from 'react-router-dom';
import { Music2, MessageCircle } from 'lucide-react';
import Logo from './Logo';
import { RESEARCH_DISCLAIMER } from '../mock/mock';
import { ALP_SOCIAL_LOGO } from '../lib/assets';

export default function Footer() {
  return (
    <footer className="bg-alp-black mt-24 relative aurora-wash">
      <div className="absolute top-0 inset-x-0 h-px alp-beam" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <Logo size={44} />
              <div className="leading-tight">
                <div className="font-serif text-alp-cream text-base tracking-[0.18em] uppercase">
                  Australian Luxe
                </div>
                <div className="text-alp-gold text-[11px] tracking-[0.3em] uppercase">
                  Peptides
                </div>
              </div>
            </div>
            <p className="text-alp-gold/90 font-serif italic text-lg">Science. Purity. Elevated.</p>
            <p className="text-alp-gray text-sm mt-3">Gold Coast, Australia &middot; Australia only</p>
          </div>

          <div>
            <h4 className="text-alp-cream text-xs tracking-[0.25em] uppercase mb-5">Shop</h4>
            <ul className="space-y-3 text-sm text-alp-gray">
              <li><Link to="/shop" className="hover:text-alp-gold transition-colors">All Products</Link></li>
              <li><Link to="/gift-cards" className="hover:text-alp-gold transition-colors" data-testid="footer-giftcards-link">Gift Cards</Link></li>
              <li><Link to="/shop?cat=Fat%20Loss%20%26%20Metabolism" className="hover:text-alp-gold transition-colors">Fat Loss &amp; Metabolism</Link></li>
              <li><Link to="/shop?cat=Skin%20%26%20Beauty" className="hover:text-alp-gold transition-colors">Skin &amp; Beauty</Link></li>
              <li><Link to="/shop?cat=Repair%20%26%20Recovery" className="hover:text-alp-gold transition-colors">Repair &amp; Recovery</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-alp-cream text-xs tracking-[0.25em] uppercase mb-5">Information</h4>
            <ul className="space-y-3 text-sm text-alp-gray">
              <li><Link to="/faq" className="hover:text-alp-gold transition-colors">FAQ</Link></li>
              <li><Link to="/calculator" className="hover:text-alp-gold transition-colors">Reconstitution Calculator</Link></li>
              <li><Link to="/shipping" className="hover:text-alp-gold transition-colors">Shipping</Link></li>
              <li><Link to="/terms" className="hover:text-alp-gold transition-colors">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-alp-gold transition-colors">Privacy Policy</Link></li>
              <li><Link to="/library" className="hover:text-alp-gold transition-colors" data-testid="footer-library-link">Client Library</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-alp-cream text-xs tracking-[0.25em] uppercase mb-5">Connect</h4>
            <ul className="space-y-3 text-sm text-alp-gray">
              <li><Link to="/contact" className="hover:text-alp-gold transition-colors">Contact Us</Link></li>
              <li><a href="mailto:support@australianluxepeptides.com" className="hover:text-alp-gold transition-colors">support@australianluxepeptides.com</a></li>
            </ul>
            <div className="flex items-center gap-4 mt-5">
              <a href="https://www.tiktok.com/@australianluxe" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-alp-gray hover:text-alp-gold transition-colors"><Music2 size={20} strokeWidth={1.5} /></a>
              <a href="https://wa.me/61435806235" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="text-alp-gray hover:text-alp-gold transition-colors"><MessageCircle size={20} strokeWidth={1.5} /></a>
              <a href="https://wa.me/61435806235" target="_blank" rel="noopener noreferrer" aria-label="Australian Luxe Peptides" className="opacity-90 hover:opacity-100 transition-opacity"><img src={ALP_SOCIAL_LOGO} alt="Australian Luxe Peptides" className="w-6 h-6 rounded-full object-cover" /></a>
            </div>
            <p className="text-alp-gray text-xs mt-2">TikTok &amp; WhatsApp @australianluxe</p>
          </div>
        </div>

        <div className="gold-divider my-10" />

        <p className="text-alp-gray/70 text-xs leading-relaxed max-w-4xl">
          {RESEARCH_DISCLAIMER}
        </p>
        <p className="text-alp-gray/50 text-xs mt-6">
          &copy; {new Date().getFullYear()} Australian Luxe Peptides. All rights reserved. Research use only.
        </p>
      </div>
    </footer>
  );
}
